import { indexTopics } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            专题合集
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按类别浏览你最感兴趣的爆料内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexTopics.map((topic) => (
            <a
              key={topic.id}
              href="#cards"
              className="group relative block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer no-underline"
            >
              <div className="aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src={topic.imageUrl}
                  alt={topic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3 md:p-4">
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {topic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{topic.desc}</p>
                <span className="inline-block mt-2 text-[11px] font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded whitespace-nowrap">
                  {topic.count}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}